import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { FacilityContextService } from '../../../context/facility-context/facility-context.service'
import { map } from 'rxjs/operators'
import { AsyncPipe } from '@angular/common'
import { ProdOrderBrowserComponent } from '../prod-order-browser/prod-order-browser.component'
import { FacilityContextMenuComponent } from '../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderToolbarColumnDirective,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-prod-order-browser-viewer',
  templateUrl: './prod-order-browser-viewer.component.html',
  styleUrls: ['./prod-order-browser-viewer.component.scss'],
  imports: [
    ElderToolbarColumnDirective,
    FacilityContextMenuComponent,
    ProdOrderBrowserComponent,
    AsyncPipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ProdOrderBrowserViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  readonly facilityId$: Observable<string>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const facilityContextService = inject(FacilityContextService)
    this.facilityId$ = facilityContextService.facility$.pipe(map((facility) => facility.id))
  }
}
